import {useMutation} from '@tanstack/react-query';
import {evaluateFaq} from '@/api/help';

export const useEvaluateFaq = () => {
  return useMutation({
    mutationFn: evaluateFaq,
  });
};
